import { render, staticRenderFns } from "./PhoenixFeatureSection.vue?vue&type=template&id=a1572ed4"
import script from "./PhoenixFeatureSection.vue?vue&type=script&lang=js"
export * from "./PhoenixFeatureSection.vue?vue&type=script&lang=js"
import style0 from "./PhoenixFeatureSection.vue?vue&type=style&index=0&id=a1572ed4&prod&module=%24s&lang=scss"




function injectStyles (context) {
  
  this["$s"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports